
function getPackageTypeForCompensationCalculatorView(packageType : string): string {
    // add mappings if needed (ex: annually -> yearly, hourly -> hr)
    
    return packageType;
}
export default getPackageTypeForCompensationCalculatorView;
